import React from 'react';
import BaseProps from "../../types/BaseProps";
import {LicenseInfo} from "../../types/LicenseInfo";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import classNames from "classnames";
import {LocaleDate} from "../../common/Date";

import "./LicenseSummary.scss";
import InvalidLicenseAlert from "./InvalidLicenseAlert";

type LicenseSummaryProps = {
  license?: LicenseInfo
}

/**
 * Renders license information such as expiration date, license type and issuer.
 */
class LicenseSummary extends React.Component<LicenseSummaryProps> {

  render() {
    const license = this.props.license;
    if (license && license.isValid) {
      return (
        <Container fluid className="LicenseSummary">
          <Row>
            <LicenseItemColumn className="LicensedTo"
                               title="Licensed to"
                               item={license.licensedTo}/>
            <LicenseItemColumn className="ValidUntil"
                               title="Valid until"
                               item={license.expiryDate}
                               type="date"/>
            <LicenseItemColumn className="LicenseVersion"
                               title="Version"
                               item={license.version}
                               type="string"/>
            <LicenseItemColumn className="PublicationDate"
                               title="Publication date"
                               item={license.publicationDate}
                               type="date"/>
          </Row>
          <Row>
            <Col className="text-muted no-padding UsageType">
              {license.typeOfUse}
            </Col>
          </Row>
        </Container>
      );
    }
    return <InvalidLicenseAlert license={license}/>;
  }

}

function LicenseItemColumn(props: BaseProps & {
  item: any,
  title: string,
  type?: 'string' | 'date'
}) {
  if (!props.item) {
    return null;
  }
  const classes = classNames("LicenseItem", props.className);
  const type = props.type ? props.type : 'string';
  return (
    <Col md="auto" className={classes}>
      <div className="LicenseItemHeader">
        {props.title}
      </div>
      <div className="LicenseItemValue">
        {type === 'string' && props.item}
        {type === 'date' && <LocaleDate date={props.item}/>}
      </div>
    </Col>
  );
}

export default LicenseSummary;
